import { IProposalOverview } from "../../common/interfaces/proposal.interface";
import { get } from "../utilities/http";
import { PROPOSAL_OVERVIEW } from "../utilities/urls";

export function geProposalOverview(): Promise<IProposalOverview> {
  return get(PROPOSAL_OVERVIEW);
}
